import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehiclePart } from '../../enums';
import VehicleHood from './vehicle-hood';
import VehicleWindow from './vehicle-window';
import VehicleRoof from './vehicle-roof';
import BodyImg from '../../assets/images/car-model/body.png';

class VehicleBody extends React.Component<VehicleModelProps, any> {
  render() {
    const { className, ...other } = this.props;

    return (
      <div className={className}>
        <VehicleHood part={VehiclePart.Front} {...other} />
        <VehicleWindow part={VehiclePart.Front} {...other} />
        <VehicleRoof {...other} />
        <VehicleWindow part={VehiclePart.Rear} {...other} />
        <VehicleHood part={VehiclePart.Rear} {...other} />
      </div>
    );
  }
}

const StyledVehicleBody = styled(VehicleBody)`
  width: 10em;
  position: relative;
  background-image: url(${BodyImg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: -1.75em;
`;

export default StyledVehicleBody;
